import React, { useEffect, useState } from 'react';
import {
  Box,
  Collapse,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Slide,
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';

import ChatBox from './ChatBox';

interface ChatProps {
  isXsScreen: boolean;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const Chat: React.FC<ChatProps> = ({ isXsScreen }) => {
  // State
  const [isChatOpen, setIsChatOpen] = useState(false);

  useEffect(() => {
    if (!isXsScreen) {
      setIsChatOpen(true);
    }
  }, []);

  const toggleChat = () => {
    setIsChatOpen((prev) => !prev);
  };

  const renderChat = () => {
    if (isChatOpen && isXsScreen) {
      return (
        <Dialog
          fullScreen
          open
          onClose={toggleChat}
          TransitionComponent={Transition}
        >
          <DialogContent sx={{ padding: 0 }}>
            <ChatBox isChatOpen={isChatOpen} onChatCollapse={toggleChat} />
          </DialogContent>
        </Dialog>
      );
    }

    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row-reverse',
          alignItems: 'stretch',
          width: isChatOpen ? '350px' : '40px',
          transition: 'width 0.3s ease-in-out',
        }}
      >
        <Collapse in={isChatOpen} orientation="horizontal">
          <ChatBox isChatOpen={isChatOpen} onChatCollapse={toggleChat} />
        </Collapse>
      </Box>
    );
  };

  return (
    <Grid item>
      <div style={{ position: 'sticky', top: 'calc(64px + 15px)' }}>
        {renderChat()}

        {!isChatOpen ? (
          <Box
            sx={{
              position: 'fixed',
              top: '150px',
              right: 0,
            }}
          >
            <IconButton
              sx={{
                backgroundColor: '#F8FAFC',
                borderRadius: '5px',
              }}
              onClick={toggleChat}
            >
              <img
                style={{ width: '22px', height: '18px' }}
                src={`${process.env.PUBLIC_URL}/images/chat/chat-collapse.png`}
                alt="chat-collapse"
              />
            </IconButton>
          </Box>
        ) : null}
      </div>
    </Grid>
  );
};

export default React.memo(Chat);
